import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark-2",
  "use": "icon-checkmark-2-usage",
  "viewBox": "0 0 18.5 13.67",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.5 13.67\" id=\"icon-checkmark-2\"><defs><style>#icon-checkmark-2 .cls-1{fill:none;stroke:#2b0;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}</style></defs><g id=\"icon-checkmark-2_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-checkmark-2_圖層_1-2\" data-name=\"圖層 1\"><polyline class=\"cls-1\" points=\"2 5.22 6.83 11.67 16.5 2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol